import api from '@/lib/api';

export const CUSTOM_INTEGRATION_SECRETS_LIST = 'CUSTOM_INTEGRATION_SECRETS_LIST';
export const CUSTOM_INTEGRATION_SECRETS_CREATE = 'CUSTOM_INTEGRATION_SECRETS_CREATE';
export const CUSTOM_INTEGRATION_SECRETS_LOAD = 'CUSTOM_INTEGRATION_SECRETS_LOAD';
export const CUSTOM_INTEGRATION_SECRETS_UPDATE = 'CUSTOM_INTEGRATION_SECRETS_UPDATE';
export const CUSTOM_INTEGRATION_SECRETS_DELETE = 'CUSTOM_INTEGRATION_SECRETS_DELETE';

const SECRET_LIST_LOADING_CHANGE = 'SECRET_LIST_LOADING_CHANGE';
const SECRET_LIST_CHANGE = 'SECRET_LIST_CHANGE';
const SECRET_ERRORS_CHANGE = 'SECRET_ERRORS_CHANGE';
const SECRET_META_CHANGE = 'SECRET_META_CHANGE';

const state = {
  secret_empty: {
    id: null,
    name: '',
    encrypted_value: '',
    created_at: null,
    updated_at: null,
  },
  secret_list: [],
  secret_list_loading: false,
  secret_errors: {},
  secret_meta: {},
};

const getters = {
  secret_empty: (state) => state.secret_empty,
};

const actions = {
  /**
   * Загружает список секретов для интеграции
   * @param {Object} context - Контекст Vuex
   * @param {Object} payload - { integrationId, params }
   * @returns {Promise}
   */
  [CUSTOM_INTEGRATION_SECRETS_LIST]({ commit, state }, { integrationId, params = {} }) {
    return api.list(
      'custom_integrations.secrets.list',
      integrationId,
      params,
      state,
      commit,
      SECRET_LIST_LOADING_CHANGE,
      SECRET_LIST_CHANGE,
      SECRET_ERRORS_CHANGE
    );
  },

  /**
   * Создает новый секрет
   * @param {Object} context - Контекст Vuex
   * @param {Object} payload - { integrationId, data }
   * @returns {Promise}
   */
  [CUSTOM_INTEGRATION_SECRETS_CREATE]({ commit, state }, { integrationId, data }) {
    return api.create(
      'custom_integrations.secrets.create',
      integrationId,
      data,
      state,
      commit,
      SECRET_LIST_LOADING_CHANGE,
      SECRET_LIST_CHANGE,
      SECRET_ERRORS_CHANGE
    );
  },

  /**
   * Загружает секрет по ID
   * @param {Object} context - Контекст Vuex
   * @param {Object} payload - { integrationId, secretId }
   * @returns {Promise}
   */
  [CUSTOM_INTEGRATION_SECRETS_LOAD]({ commit, state }, { integrationId, secretId }) {
    return api.load(
      'custom_integrations.secrets.load',
      [integrationId, secretId],
      state,
      commit,
      SECRET_LIST_LOADING_CHANGE,
      SECRET_LIST_CHANGE,
      SECRET_ERRORS_CHANGE
    );
  },

  /**
   * Обновляет существующий секрет
   * @param {Object} context - Контекст Vuex
   * @param {Object} payload - { integrationId, secretId, data }
   * @returns {Promise}
   */
  [CUSTOM_INTEGRATION_SECRETS_UPDATE]({ commit, state }, { integrationId, secretId, data }) {
    return api.update(
      'custom_integrations.secrets.update',
      [integrationId, secretId],
      data,
      state,
      commit,
      SECRET_LIST_LOADING_CHANGE,
      SECRET_LIST_CHANGE,
      SECRET_ERRORS_CHANGE
    );
  },

  /**
   * Удаляет секрет
   * @param {Object} context - Контекст Vuex
   * @param {Object} payload - { integrationId, secretId }
   * @returns {Promise}
   */
  [CUSTOM_INTEGRATION_SECRETS_DELETE]({ commit, state }, { integrationId, secretId }) {
    return api.delete(
      'custom_integrations.secrets.delete',
      [integrationId, secretId],
      state,
      commit,
      SECRET_LIST_CHANGE
    );
  },
};

const mutations = {
  [SECRET_LIST_LOADING_CHANGE](state, data) {
    state.secret_list_loading = data;
  },
  [SECRET_LIST_CHANGE](state, data) {
    if (data && data.data) {
      state.secret_list = data.data;
      const total = data.total || 0;
      const per_page = data.per_page || 20;
      const current_page = data.page || data.current_page || 1;
      const last_page = data.last_page || Math.ceil(total / per_page) || 1;

      state.secret_meta = {
        total: total,
        per_page: per_page,
        current_page: current_page,
        last_page: last_page,
      };
    } else if (data && Array.isArray(data)) {
      state.secret_list = data;
      state.secret_meta = {};
    } else {
      state.secret_list = [];
      state.secret_meta = {};
    }
  },
  [SECRET_ERRORS_CHANGE](state, data) {
    state.secret_errors = data || {};
  },
  [SECRET_META_CHANGE](state, data) {
    state.secret_meta = data || {};
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
